import { Component, Input, OnInit } from '@angular/core';
import { MenuService } from '@captiveaire/menu';
import * as _ from 'lodash';
import { NavMenu, NavMenuItem } from '../../src';
import { IDictionary } from '@caslink/common-client/ng-app/dictionary/IDictionary';

@Component({
    selector: 'cl-area-menu',
    templateUrl: './area-menu.component.html',
    styleUrls: ['area-menu.component.scss']
})
export class AreaMenuComponent implements OnInit {
    static $name: string = 'clAreaMenu';
    @Input() emptyListCaption: string;
    @Input() menu: NavMenu;

    isEmpty: boolean;
    items: IDictionary<NavMenuItem>;

    constructor(
        private menuService: MenuService
    ) {
    }

    ngOnInit(): void {
        if (!this.menu) {
            return;
        }
        if (this.menu.menuContext) {
            this.menuService.filterMenu(this.menu).then(result => {
                this.setItems(result.items);
            });
        } else {
            this.setItems(this.menu.items);
        }
    }

    private setItems(items) {
        this.items = items;
        this.isEmpty = _.isEmpty(this.items);
    }
}
